import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from './store'
import ElementUI from 'element-ui'
import '@/assets/custom-component.js'
import '@/assets/iconfont/iconfont.css'
import '@/theme/custom-el.scss'
import 'element-ui/lib/theme-chalk/reset.css'
import 'element-ui/lib/theme-chalk/index.css'
import VueI18n from "vue-i18n";
import messages from '@/locale/index'
import loading from './components/loading/loading.js'
Vue.use(ElementUI, { size: 'mini' })
Vue.use(VueI18n)
// 初始化语言
const i18n = new VueI18n({
  locale: 'chinese', // language为设置的语言名称，例如english或french
  messages // message为语言字典，需要自己配置
})

/**
/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false
/**
 * @description 全局注册应用配置
 */

new Vue({
  router,
  i18n,
  store,
  render: h => h(App),
  created() {
    // 提取登录状态
    let accessToken = localStorage.getItem("access_token");
    this.$store.commit('setToken', accessToken);
    let user = localStorage.getItem("user_info");
    user = user ? JSON.parse(user) : {};
    this.$store.commit('setUserInfo', user);
    this.$root.$on("relogin", () => {
      authMap.clear();
    })
  }
}).$mount('#app')

const authMap = new Map();
Vue.prototype.$loading = loading;
Vue.prototype.$auth = function (auth) {
  if (!auth) {
    return true;
  }
  let result = authMap.get(auth);
  if (result === undefined) {
    let authorities = store.state.userInfo.authorities;
    result = auth === 'anon' || (auth && authorities && authorities.indexOf(auth) >= 0);
    authMap.set(auth, result);
  }
  return result;
};
